import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'payCentre',
		component: () => import('../views/payCentre/payCentre.vue'),
		redirect: '/',
		children: [
			{
				path: '/',
				name: 'payCentreindex',
				meta: '主页',
				component: () => import('../views/payCentre/view/payCentreindex.vue'),
			},
			{
				path: 'expense',
				name: 'expense',
				meta: '消费明细',
				component: () => import('../views/payCentre/view/expense.vue'),
			},
			{
				path: 'deduction',
				name: 'deduction',
				meta: '扣单明细',
				component: () => import('../views/payCentre/view/Deduction.vue'),
			},
			{
				path: 'coupons',
				name: 'coupons',
				meta: '优惠券',
				component: () => import('../views/payCentre/view/coupons.vue'),
			},
			{
				path: 'rechargepay',
				name: 'rechargepay',
				meta: '充值数量',
				component: () => import('../views/payCentre/view/rechargepay.vue'),
			},
			{
				path: 'pay',
				name: 'pay',
				meta: '订单支付',
				component: () => import('../views/pay/pay.vue'),
			},
			{
				path: 'logistics-order',
				name: 'logisticsOrder',
				meta: '物流订单管理',
				component: () => import('../views/logistics/LogisticsOrder.vue'),
			},
			{
				path: 'logistics-order-detail',
				name: 'logisticsOrderDetail',
				meta: '物流订单管理',
				component: () => import('../views/logistics/LogisticsOrderDetail.vue'),
			},
			//马帮应用市场
			{
				path: 'yingyong',
				name: 'yingyong',
				component: () => import('../views/application/yingyong.vue'),
				redirect: '/yingyong/platform',
				children: [
					{
						//平台类
						path: 'platform',
						name: 'platform',
						meta: '平台类产品',
						component: () => import('../views/application/platform/platform.vue'),
					},
					{
						path: 'tool',
						name: 'tool',
						meta: '工具类产品',
						component: () => import('../views/application/tool/tool_product.vue'),
					},
					{
						path: 'serve',
						name: 'serve',
						meta: '服务类产品',
						component: () => import('../views/application/serve/serve.vue'),
					},
					{
						path: 'purchased',
						name: 'purchased',
						meta: '加购类产品',
						component: () => import('../views/application/purchased/purchased.vue'),
					},
					{
						path: 'cloudservices',
						name: 'cloudservices',
						meta: '服务器',
						component: () => import('../views/application/cloudservices/cloud_services.vue'),
					},
					{
						path: 'openapi',
						name: 'openapi',
						meta: '开放平台api',
						component: () => import('../views/application/openapi/open_api.vue'),
					},
				],
			},
			//订单管理
			{
				path: 'order',
				name: 'order',
				component: { render: (e) => e('router-view') },
				redirect: '/order/orderlist',
				children: [
					{
						path: 'orderlist',
						name: 'orderlist',
						meta: '订单列表',
						component: () => import('@/views/order/order.vue'),
					},
					{
						//详情
						path: 'orderDetail',
						name: 'orderDetail',
						meta: '订单详情',
						component: () => import('../views/order/orderDetail.vue'),
					},
				],
			},
		],
	},
	// 第三方调用本地支付页面
	{
		path: '/other',
		name: 'other',
		meta: '支付',
		component: () => import('../views/pay/index.vue'),
		children: [
			{
				path: 'pay',
				name: 'otherPay',
				meta: '支付',
				component: () => import('../views/pay/pay.vue'),
			},
		],
	},
	// shopify支付成功页面
	{
		path: '/shopify',
		name: 'shopify',
		meta: '支付成功',
		component: () => import('../views/pay/shopify.vue'),
	},
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
})

router.beforeEach((to, from, next) => {
	if (to.name == 'otherPay' || to.name === 'shopify') {
		next()
	} else if (to.query.sign || to.query.ucenterToken) {
		if (window._hmt) {
			if (to.path) {
				window._hmt.push(['_trackPageview', '/#' + to.path])
			}
		}
		next()
	} else {
		if (sessionStorage.getItem('mabangerp_token')) {
			if (window._hmt) {
				if (to.path) {
					window._hmt.push(['_trackPageview', '/#' + to.path])
				}
			}
			next()
		} else {
			window.location.href = 'https://www.mabangerp.com/'
		}
	}
})

export default router
